"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_form_1 = require("redux-form");
var redux_1 = require("redux");
var feedReducer_1 = __importDefault(require("../util/feed/feedReducer"));
var feedReducer_2 = __importDefault(require("../util/bountyFeed/feedReducer"));
var userReducer_1 = __importDefault(require("../user/userReducer"));
var postReducer_1 = __importDefault(require("../post/postReducer"));
var EditorReducer_1 = __importDefault(require("../util/dashboard/EditorReducer"));
var ImageAddReducer_1 = __importDefault(require("../util/articleEditor/imageAdd/ImageAddReducer"));
var SidebarReducer_1 = __importDefault(require("../sidebar/SidebarReducer"));
var articlesReducer_1 = __importDefault(require("../yourtrybe/articles/articlesReducer"));
var SocialFeedReducer_1 = __importDefault(require("../yourtrybe/social/SocialFeedReducer"));
var FollowingReducer_1 = __importDefault(require("../yourtrybe/following/FollowingReducer"));
var userReviewReducer_1 = __importDefault(require("../user-review/userReviewReducer"));
var FriendsReducer_1 = __importDefault(require("../yourtrybe/friends/FriendsReducer"));
var signUpReducer_1 = __importDefault(require("../sign-up/signUpReducer"));
var settingsReducer_1 = __importDefault(require("../yourtrybe/settings/settingsReducer"));
exports.default = (0, redux_1.combineReducers)({
    form: redux_form_1.reducer,
    feed: feedReducer_1.default,
    bountyFeed: feedReducer_2.default,
    user: userReducer_1.default,
    post: postReducer_1.default,
    editor: EditorReducer_1.default,
    image: ImageAddReducer_1.default,
    articles: articlesReducer_1.default,
    sidebar: SidebarReducer_1.default,
    socialFeed: SocialFeedReducer_1.default,
    userReview: userReviewReducer_1.default,
    following: FollowingReducer_1.default,
    friends: FriendsReducer_1.default,
    signUp: signUpReducer_1.default,
    settings: settingsReducer_1.default,
});
